<template>
    <div class="socials">
        <div class="column" v-for="(social, name) in socials" :key="name">
            <a class="social" rel="nofollow" target="_blank" :href="social.url">
                <component :is="social.icon" />
            </a>
        </div>
    </div>
</template>
<script>
import SocialInstagram from "@/components/SocialInstagram";
import SocialLinkedin from "@/components/SocialLinkedin";

export default {
    components: {
        SocialInstagram,
        SocialLinkedin
    },
    data() {
        return {
            socials: {
                instagram: {
                    url: "https://www.instagram.com/indigenfactory/",
                    icon: SocialInstagram
                },
                linkedin: {
                    url: "https://fr.linkedin.com/company/indigen-factory",
                    icon: SocialLinkedin
                }
            }
        };
    }
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base

.socials
    padding-top: calc(var(--line-base) * 1.5)
    display: flex
    justify-content: center

    +media('>=small')
        padding-top: var(--section-padding)
        padding-bottom: var(--section-padding)

.social
    svg
        display: inline
        width: var(--line-base)
        height: var(--line-base)
</style>
